
/**
 * Identify if NODE_ENV is 'development'
 */
export function isEnvDevelop () {
  return typeof process !== 'undefined' && process.env?.NODE_ENV === 'development';
}
